module.exports = __webpack_public_path__ + "img/sidebar-followers.b9fe81ce.svg";